import 'vanilla-cookieconsent/dist/cookieconsent.css';
import * as CookieConsent from 'vanilla-cookieconsent';
// eslint-disable-next-line import/extensions
import i18n from '@/i18n/index.js';
import { watch } from 'vue';
import { applyConsentChange, updateGtagConsent } from '@/services/analytics/googleAnalytics.js';
import deTranslations from '../../i18n/locales/de.json';
import enTranslations from '../../i18n/locales/en.json';

export default {
  install: (app) => {
    const initializeCookieConsent = (locale) => {
      const normalizedLocale = locale.split('-')[0];
      const options = {
        cookie: {
          name: 'cc_cookie',
          expiresAfterDays: (acceptType) => {
            const days = acceptType === 'all' ? 365.25 : 7;
            return days;
          },
          path: '/',
          secure: true,
          sameSite: 'Lax',
        },
        callbacks: {
          onAcceptAll: () => {
            updateGtagConsent({ analytics_storage: 'granted' });
            applyConsentChange('granted');
            updateGtagConsent({ ad_storage: 'granted' });
          },
          onRejectAll: () => {
            updateGtagConsent({ analytics_storage: 'granted' });
            updateGtagConsent({ ad_storage: 'denied' });
            applyConsentChange('denied');
          },
        },
        categories: {
          necessary: {
            enabled: true,
            readOnly: true,
          },
          analytics: {
            services: {
              ga: {
                label: 'Google Analytics',
                onInitialise: () => {
                  updateGtagConsent({ 'analytics_storage': 'granted' });
                  applyConsentChange('granted');
                },
                onAccept: () => {
                  updateGtagConsent({ 'analytics_storage': 'granted' });
                  applyConsentChange('granted');
                },
                onConsent: () => {
                  updateGtagConsent({ 'analytics_storage': 'granted' });
                  applyConsentChange('granted');
                },
                onReject: () => {
                  if (localStorage.getItem('gaRegisteredUserConsent') !== 'true') {
                    updateGtagConsent({ 'analytics_storage': 'denied' });
                    applyConsentChange('denied');
                  }
                },
                cookies: [
                  { name: /^(_ga|_gid)/ },
                ],
              },
            },
          },
          marketing: {
            label: 'Marketing and Ads',
            services: {
              googleAds: {
                label: 'Google Ads',
                onInitialise: () => {
                },
                onAccept: () => {
                  updateGtagConsent({ 'ad_storage': 'granted' });
                  updateGtagConsent({ 'ad_user_data': 'granted' });
                  updateGtagConsent({ 'ad_personalization': 'granted' });
                  applyConsentChange('granted');
                },
                onReject: () => {
                  updateGtagConsent({ 'ad_storage': 'denied' });
                  updateGtagConsent({ 'ad_user_data': 'denied' });
                  updateGtagConsent({ 'ad_personalization': 'denied' });
                },
              },
              linkedin: {
                label: 'LinkedIn Insight',
                onInitialise: () => {
                },
                onAccept: () => {
                  updateGtagConsent({ 'ad_storage': 'granted' });
                },
                onReject: () => {
                },
              },
              metaPixel: {
                label: 'Meta Pixel',
                onInitialise: () => {
                },
                onAccept: () => {
                  updateGtagConsent({ 'ad_storage': 'granted' });
                },
                onReject: () => {
                },
              },
            },
          },
        },
        language: {
          default: normalizedLocale,
          autoDetect: false,
          translations: {
            en: enTranslations.cookieConsent,
            de: deTranslations.cookieConsent,
          },
        },
      };

      if (app.config.globalProperties.$CookieConsent) {
        delete app.config.globalProperties.$CookieConsent;
      }

      app.config.globalProperties.$CookieConsent = CookieConsent;
      app.config.globalProperties.$CookieConsent.run(options);
    };

    setTimeout(() => {
      initializeCookieConsent(i18n.global.locale.value);
    }, 100);

    watch(
      () => i18n.global.locale.value,
      (newLocale) => {
        initializeCookieConsent(newLocale);
      },
    );
  },
};
